module.exports = __webpack_public_path__ + "img/big-boy.01e546f.jpg";